import clsx from 'clsx';

const STEPS = ['方法を選ぶ', '求職者を設定', '提案を開始'] as const;

type Props = {
  /** アクティブ（青）にする段階数。1〜3 */
  activeUpTo: number;
  /** lg: ステップ1のヒーロー表示（ラベル18px） / sm: ステップ2のヘッダー表示（ラベル14px） */
  size?: 'sm' | 'lg';
  /** 指定時は「方法を選ぶ」をリンクにして方法選択へ戻す */
  onBackToMethod?: () => void;
};

export default function StepIndicator({ activeUpTo, size = 'sm', onBackToMethod }: Props) {
  return (
    <div className="flex items-center gap-sm">
      {STEPS.map((label, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber <= activeUpTo;
        const isBackLink = stepNumber === 1 && onBackToMethod !== undefined;
        const labelClassName = clsx(
          'font-bold whitespace-nowrap',
          size === 'lg' ? 'text-heading-sm' : 'text-body-sm',
          isActive ? 'text-black' : 'text-placeholder'
        );
        return (
          <div key={label} className="flex items-center gap-sm">
            <span
              className={clsx(
                'flex shrink-0 items-center justify-center rounded-full text-body-xs font-bold',
                size === 'lg' ? 'size-6' : 'size-5',
                isActive ? 'bg-primary text-white' : 'bg-disabled text-placeholder'
              )}
            >
              {stepNumber}
            </span>
            {isBackLink ? (
              <button
                type="button"
                onClick={onBackToMethod}
                className={clsx(labelClassName, 'border-0 bg-transparent text-primary underline')}
              >
                {label}
              </button>
            ) : (
              <span className={labelClassName}>{label}</span>
            )}
            {index < STEPS.length - 1 && <span className="h-px w-11.5 bg-border" />}
          </div>
        );
      })}
    </div>
  );
}
